import Roles from '../../layouts/role';
import Header from '../../components/shared/layout/header';
import Footer from '../../components/shared/layout/footer';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  mainContent: {
    minHeight: 'calc(100vh - 137px)',
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: 74
  },
  absoluteContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    display: 'grid',
    gridTemplateRows: '180px 1fr',
    zIndex: 1,
  },
  lightBack: {
    backgroundColor: 'rgb(237,244,255)',
  },
  whiteBack: {
    backgroundColor: '#fff',
  },
  body: {
    position: 'relative',
    backgroundColor: '#fff',
    maxWidth: '555px',
    width: '100%',
    boxShadow: '0 24px 40px -16px rgba(6, 31, 128, 0.2)',
    padding: '25px',
    zIndex: 2,
    display:'flex',
    flexFlow:'column',
    alignItems:'center',
    minHeight: 276,
    '& ul': {
      padding: 0,
    },
    '& li': {
      textAlign:'center',
      padding: '4px 19px',
      border: '1px solid #C5D8FF',
      borderRadius: 4,
      boxSizing:'border-box',
      color: '#005EB8',
      margin: '4px 0',
      '&:hover,&:focus': {
        backgroundColor:'#fafdff',
        outline:'none',
        boxShadow:'0px 0px 0px 1px #8FB8EF'
      }
    },
  },
  title: {
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#333333',
  },
  quadrado1: {
    width: 48,
    height: 48,
    position: 'absolute',
    backgroundColor: 'rgb(64,139,252)',
    top: -48,
    left: 0
  },
  quadrado2: {
    width: 48,
    height: 48,
    position: 'absolute',
    backgroundColor: 'rgb(64,139,252)',
    top: -48,
    right: 0
  },
  quadrado3: {
    width: 48,
    height: 48,
    position: 'absolute',
    backgroundColor: 'rgb(64,139,252)',
    bottom: 0,
    right: -48
  },
  quadrado4: {
    width: 48,
    height: 48,
    position: 'absolute',
    backgroundColor: 'rgb(147,189,252)',
    top: 0,
    left: -48
  },
  quadrado5: {
    width: 48,
    height: 48,
    position: 'absolute',
    backgroundColor: 'rgb(147,189,252)',
    bottom: -48,
    right: 0
  },

}));

const RolesPages = () => {

  const classes = useStyles();


  return (
    <CssBaseline>
      <Header />
      <div className={classes.mainContent}>
        <div className={classes.absoluteContainer}>
          <div className={classes.lightBack}></div>
          <div className={classes.whiteBack}></div>
        </div>
        <div className={classes.body}>
          <p className={classes.title}>Você quer fazer acesso com qual perfil?</p>
          <Roles />
          <div className={classes.quadrado1}></div>
          <div className={classes.quadrado2}></div>
          <div className={classes.quadrado3}></div>
          <div className={classes.quadrado4}></div>
          <div className={classes.quadrado5}></div>
        </div>
      </div>
      <Footer noMargin />
    </CssBaseline>
  )
}

export default RolesPages;
